import React from 'react';

import Layout from '../components/Layout';

import Footer from '../components/Footer';
import SocialLinks from '../components/SocialLinks';
import Header from '../components/Header';
import SimilarArticles from '../components/SimilarArticles';


require('typeface-Poppins')


const KeywordTemplate = ({ pageContext, ...props }) => {

    return (<Layout>
        <Header frontPage={false} />
        <header className="masthead ">
            <div className="bg">
                <div className="bgContent post-header" />
            </div>
            <div className="container d-flex h-100 align-items-center post">
                <div className="mx-auto text-center">
                    <h1 className="mx-auto my-0 heading">{pageContext.keyword}</h1>
                </div>
            </div>
        </header>
        <div className="site-container blog-post">
            <div className="container">
                <SimilarArticles keywords={[pageContext.keyword]} />
            </div>
        </div>
        {/* <Pagination currentPage={props.pageContext.currentPage} totalPages={props.pageContext.numPages} uri="/blog" /> */ }
    <SocialLinks />
        <Footer />
    </Layout >)
};

export default KeywordTemplate;
